export enum RequisitosGenerales {
    CapacidadTecnica = 1,
    CapacidadOperativa = 2
}
